{
  "codes.ADAPTER_001": "Invalid adapter configuration",
  "codes.ADAPTER_002": "Failed to connect to target system",
  "codes.ADAPTER_003": "Write operation failed",
  "codes.ADAPTER_004": "Batch operation failed",
  "codes.ADAPTER_005": "Circuit breaker is open",
  "codes.ADAPTER_006": "Rate limit exceeded",
  "codes.ADAPTER_007": "Authentication failed",
  "codes.ADAPTER_008": "Operation timed out",
  "codes.ADAPTER_009": "Unknown adapter type",
  "codes.ADAPTER_010": "OAuth2 token refresh failed",
  "codes.LDA_001": "LDA database connection failed",
  "codes.LDA_002": "Config load exceeded timeout",
  "codes.LDA_003": "Configuration validation failed",
  "codes.DEBOUNCER_001": "Batch write failed, messages nacked",
  "codes.DEBOUNCER_002": "Global buffer cap reached",
  "codes.PUBSUB_001": "Pub/Sub subscription(s) do not exist",
  "codes.SHADOW_001": "Invalid SQL identifier",
  "codes.SHADOW_002": "Shadow table creation failed",
  "codes.SHADOW_003": "Shadow table drop failed",
  "codes.SHADOW_005": "Advisory lock timeout",
  "codes.SHADOW_006": "Shadow table alter failed",
  "codes.SHADOW_007": "Shadow table sync failed",
  "notFound": "{{resource}} not found: {{identifier}}",
  "unauthorized": "Authentication required",
  "forbidden": "Access to this {{resource}} is not permitted",
  "validationFailed": "Validation failed",
  "versionMismatch": "The {{resource}} has been modified by another user. Please refresh.",
  "unknownError": "An unexpected error occurred",
  "networkError": "Unable to connect to the server"
}
